import {IoTreeNodeTypeModel} from '../../../../modules/imaging/models/io-tree-node-type.model';

export class GetDocumentThumbnailModel {
  id: string;
  tagEnumId: string;
  caseWorkItemId: string;
  caseWorkItemToothId: string;
  patientId: string;
  toothId: string;
  patientCaseId: string;
  toothNumberingId: string;

  // patient, case, tooth
  type: IoTreeNodeTypeModel;
}
